export default __webpack_public_path__ + "static/image_720-ace2dd050fc818cc298a9517f9447dea.png";